export default __webpack_public_path__ + "static/media/company-bg-min.78442ecc.png";